import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { RoutesList } from '@waste/routes/Routes';
import { useWasteStore } from '@waste/store/store';
import { CaseIDProps } from '@waste/store/storeSlices/wasteDetails';
import * as Sentry from '@sentry/react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const submitData = async (payload: any) => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_APIM_BASE_URL}/waste-reports/v1/`,
      {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
          'Ocp-Apim-Subscription-Key': `${import.meta.env.VITE_APIM_API_KEY as string}`,
          'content-type': 'application/json',
        },
      },
    );
    const submitResponse = (await response.json()) as CaseIDProps;
    if (!submitResponse || !submitResponse.case_reference) {
      throw new Error('Failed to submit report');
    }
    return submitResponse;
  } catch (error) {
    throw new Error((error as Error).message);
  }
};

export const useHandleSubmit = () => {
  const navigate = useNavigate();
  const { updateConfirmation } = useWasteStore();

  return useMutation({
    mutationFn: submitData,
    onSuccess: (data) => {
      const result = data as CaseIDProps;
      updateConfirmation(result);
      navigate(RoutesList.CONFIRMATION);
    },
    onError: (error) => {
      Sentry.captureException(error);
      navigate(RoutesList.CONFIRMATION);
    },
  });
};
